import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { selectUnauthenticatedRedirectionPath } from '../../../accounts/selectors/unauthenticated-redirection-path.selector.ts';
import { selectUserAuthStatus } from '../../../accounts/selectors/user-auth-status.selector.ts';
import { useAppSelector } from '../../../main/hooks/use-app-selector.ts';
import { selectAppRedirectionItemTarget } from '../../../main/selectors/app-redirection-item-target.selector.ts';

interface Props {
  children: ReactNode;
}

export const AccountScreenProtector: FC<Props> = ({ children }) => {
  const location = useLocation();

  const isAuthenticated = useAppSelector(selectUserAuthStatus);
  const targetPath = useAppSelector(selectUnauthenticatedRedirectionPath);
  const redirectionItemTarget = useAppSelector((state) =>
    selectAppRedirectionItemTarget(state, { currentPath: location.pathname })
  );

  if (!isAuthenticated) {
    return <Navigate to={targetPath} />;
  }

  if (redirectionItemTarget) {
    return <Navigate to={redirectionItemTarget.path} replace={true} />;
  }

  return children;
};
